module.exports = __webpack_public_path__ + "public/SiteIcons/defaultHomeIcon.svg?815f6792";